type CloseFn = () => void;

const filters = new Map<string, CloseFn>();

export function registerFilter(id: string, close: CloseFn): void {
  filters.set(id, close);
}

export function unregisterFilter(id: string): void {
  filters.delete(id);
}

export function closeAllOtherFilters(currentId: string): void {
  filters.forEach((close, id) => {
    if (id !== currentId) {
      close();
    }
  });
}
